/**
 * Project Frontend Application scripts
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

'use strict';

import Vue          from 'vue';
import AOS          from 'aos';
import xhr          from './xhr';
import Events       from './events';
import Dispatcher   from './dispatcher';
import components   from '../components';
import Breakpoints  from '../utils/breakpoints';
import isScrolling  from '../utils/isScrolling';
import Module       from '../modules';

export default class {

  constructor() {

    this.xhr = xhr;
    this.event = Events;
    this.dispatcher = new Dispatcher();

  }

  init(url) {

    this.url = url;

    let el = "#app";

    // this.vue = new Vue({
    //   el, url, components
    // });

    // new isScrolling('body');
    // new Module.OffCanvas('#offcanvas');
    // new Module.Footer();
    // new Module.Product();
    // new Breakpoints();

    // AOS.init();
    
    this.grid = new Module.ImageGrid('#grid', {
      itemSelector: '.grid__brick',
      layoutMode: 'masonry'
    });
  
  }

}
